import React from 'react'
import { NavLink, Route, Routes } from 'react-router-dom'
import { buildRoutePath, nestedRoutePath, routes } from '../../../constants/routes'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Allergens from './allergens'
import DietaryRestrictions from './dietary-restrictions'
import Occasions from './occasions'
import Cuisines from './cuisines'
import ServiceStyles from './service-styles'
import Vibes from './vibes'

const SettingsIndex = () => {
    return (
        <>
            <div className="section-header">
                <span className="title">Settings</span>
            </div>
            <div className="dashboard-wrapper">
                <div className="sidebar">
                    <div className="side-nav">
                        <NavLink to={buildRoutePath(routes.adminAllergensIndex.path)}>
                            <FontAwesomeIcon icon="person-dots-from-line" /> Allergens
                        </NavLink>
                        <NavLink to={buildRoutePath(routes.adminDietaryRestrictionsIndex.path)}>
                            <FontAwesomeIcon icon="circle-exclamation" /> Dietary Restrictions
                        </NavLink>
                        <NavLink to={buildRoutePath(routes.adminOccasionsIndex.path)}>
                            <FontAwesomeIcon icon="heart" /> Occasions
                        </NavLink>
                        <NavLink to={buildRoutePath(routes.adminCuisinesIndex.path)}>
                            <FontAwesomeIcon icon="carrot" /> Cuisines
                        </NavLink>
                        <NavLink to={buildRoutePath(routes.adminServiceStylesIndex.path)}>
                            <FontAwesomeIcon icon="bowl-rice" /> Service Styles
                        </NavLink>
                        <NavLink to={buildRoutePath(routes.adminVibesIndex.path)}>
                            <FontAwesomeIcon icon="hand-sparkles" /> Vibes
                        </NavLink>
                    </div>
                </div>
                <div className="main">
                    <Routes>
                        <Route path={nestedRoutePath(routes.adminSettingsIndex.path, routes.adminAllergensIndex.path, true)} element={<Allergens />} />
                        <Route path={nestedRoutePath(routes.adminSettingsIndex.path, routes.adminDietaryRestrictionsIndex.path, true)} element={<DietaryRestrictions />} />
                        <Route path={nestedRoutePath(routes.adminSettingsIndex.path, routes.adminOccasionsIndex.path, true)} element={<Occasions />} />
                        <Route path={nestedRoutePath(routes.adminSettingsIndex.path, routes.adminCuisinesIndex.path, true)} element={<Cuisines />} />
                        <Route path={nestedRoutePath(routes.adminSettingsIndex.path, routes.adminServiceStylesIndex.path, true)} element={<ServiceStyles />} />
                        <Route path={nestedRoutePath(routes.adminSettingsIndex.path, routes.adminVibesIndex.path, true)} element={<Vibes />} />
                    </Routes>
                </div>
            </div>
        </>
    )
}

export default SettingsIndex
